import React from 'react'
import { viewEnums } from '..'
import styled from 'styled-components'

const SwitchButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${({ theme }) => theme.bg0};
  transition: all 300ms;

  svg {
    stroke: rgb(195, 197, 203);
  }

  &:hover {
    background: ${({ theme }) => theme.bg1};
  }
`

interface SwitchViewProps {
  switchView: viewEnums
  setSwitchView: (value: viewEnums) => void
}

export const LOCAL_STORAGE_VIEW_KEY = 'itemView'

const SwitchView: React.FC<SwitchViewProps> = ({ switchView, setSwitchView }) => {
  const handleSwitch = () => {
    const newValue = switchView === 'card' ? 'table' : 'card'
    localStorage.setItem(LOCAL_STORAGE_VIEW_KEY, newValue)
    setSwitchView(newValue)
  }

  return (
    <SwitchButton onClick={() => handleSwitch()}>
      {switchView === 'card' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-layout-grid"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
          <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
          <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
          <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-table"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
          <path d="M3 10h18" />
          <path d="M10 3v18" />
        </svg>
      )}
    </SwitchButton>
  )
}
export default SwitchView
